<template>
    <Head title="Dashboard: Авансовые балансы"/>

    <authenticated-layout :notifications="notifications" >

        <v-navigation />

        <div v-if="result" class="flex flex-col bg-white p-4">
            <h1 class="text-lg pb-4">Авансовые балансы</h1>
            <div class="grid grid-cols-7 gap-x-2 border-b  items-center">
                <strong class="row-span-2 col-span-3">Адрес</strong>
                <strong class="row-span-2 text-center">Сеть</strong>
                <strong class="row-span-2 text-center">Монета</strong>
                <strong class="col-span-2 text-center">Баланс</strong>
                <strong class="text-right text-sm">Сервиса</strong>
                <strong class="text-right text-sm">Блокчейна</strong>
            </div>
            <div
                class="grid grid-cols-7 p-1 gap-2"
                :class="{'bg-gray-100': index%2, 'text-gray-400': !row.active}"
                v-for="(row, index) of result.addresses"
            >
                <strong class="col-span-3 truncate" :title="row.address">{{ row.address }}</strong>
                <span class="text-center">{{ row.network }}</span>
                <span class="text-center">{{ row.currency }}</span>
                <span class="text-right">{{ row.balance.service }}</span>
                <span class="text-right">{{ blockchainBalance[row.address]  ||  '???' }}</span>
            </div>
        </div>

    </authenticated-layout>

</template>

<script>
import {Head, Link} from '@inertiajs/inertia-vue3';
import AuthenticatedLayout from '@/Layouts/Authenticated';
import VNavigation from '@/Components/Navigation/Dashboard';
import VButton from '@/Components/Button';

export default {
    components: {
        Head, Link,
        AuthenticatedLayout,
        VNavigation,
        VButton,
    },
    props: {
        success: Boolean,
        result: Object,
        notifications: Array,
    },
    data() {
        return {
            blockchainBalance: {},
        }
    },
    mounted() {
        const { addresses } = this.result;
        const addr = [];
        for (const row of addresses) {
            const {address, currency, network} = row;
            if(!currency ||  !network) continue;
            addr.push({address, coin: currency, network});
        }
        axios.post(this.route('addresses.blockchain-balance'), { addresses: addr })
            .then(res => this.blockchainBalance = res.data.result);
    },
}
</script>
